import { CoordinatorService } from './coordinator.service';
import { Script } from './script';

export type TAG =
    | 'ratings'
    | 'tags'
    | 'views'
    | 'keywords'
    | 'databins'
    | 'general'
    | 'overlaps'
    | 'train'
    | 'team'
    | 'attachments'
    | 'duplkeys'
    | 'cache';

export class Section {
    private _title: string;

    constructor(
        public coords: CoordinatorService,
        public tag: TAG,
        private _script?: Script,
    ) {
        this._title = this.tag;
        if (this.tag == 'views') this._title = 'subsets';
        if (this.tag == 'general') this._title = 'project_details';
    }

    get title() {
        return this.coords.text(this._title);
    }

    get isScript() {
        return !!this._script;
    }

    get script() {
        return this._script;
    }
}
